import { render, staticRenderFns } from "./DwellingEdit.vue?vue&type=template&id=52f1a1f2&"
import script from "./DwellingEdit.vue?vue&type=script&lang=js&"
export * from "./DwellingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports